import React from 'react';

// Animated brand orb — meridian circles ("Circles") revolving together into a spinning sphere,
// friend-dots riding the rings, glowing poles where the circles meet. Mirrors the app's
// cold-start / login hero so web and mobile read the same.
const RINGS = [
  { deg: 0, color: '#6366F1', dot: { top: '0%', left: '50%', color: '#818cf8' } },
  { deg: 30, color: '#7065f0', dot: { top: '20%', left: '8%', color: '#a5b4fc' } },
  { deg: 60, color: '#8064ee' },
  { deg: 90, color: '#9063ec', dot: { top: '78%', left: '82%', color: '#c4b5fd' } },
  { deg: 120, color: '#a062ea' },
  { deg: 150, color: '#b061e8', dot: { top: '30%', left: '88%', color: '#d8b4fe' } },
];

export default function SphereOrb({ size = 132 }) {
  return (
    <div className="sso" style={{ width: size, height: size }} aria-hidden="true">
      <span className="sso-halo" />
      <div className="sso-sphere">
        {RINGS.map((r) => (
          <div key={r.deg} className="sso-ring" style={{ transform: `rotateY(${r.deg}deg)`, borderColor: r.color }}>
            {r.dot && <i className="sso-dot" style={{ top: r.dot.top, left: r.dot.left, background: r.dot.color }} />}
          </div>
        ))}
        <div className="sso-ring" style={{ transform: 'rotateX(90deg)', borderColor: '#7c6cf2' }} />
        <div className="sso-ring" style={{ transform: 'rotateX(90deg) scale(0.62)', borderColor: '#9b6cf0', opacity: 0.7 }} />
        <i className="sso-pole" style={{ top: '-4px' }} />
        <i className="sso-pole" style={{ bottom: '-4px' }} />
      </div>
    </div>
  );
}
